export default "__VITE_ASSET__D2BG5a6m__"